import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname, search } = useLocation();

    useEffect(() => {
        // Immediate scroll to top for window and document element
        window.scrollTo(0, 0);
        if (document.documentElement) {
            document.documentElement.scrollTo(0, 0);
        }
    }, [pathname, search]);

    return null;
};

export default ScrollToTop;
